'use client';
var classes = {"root":"m_9df02822","content":"m_54c44539","inner":"m_1f958f16","header":"m_d0e2b9cd"};

export { classes as default };
//# sourceMappingURL=Modal.module.css.mjs.map
